/* eslint-disable no-undef */

__webpack_nonce__ =
  window.context && (window.context.nonce || window.context.nonceToken)
    ? window.context.nonce || window.context.nonceToken
    : window.nonceToken
      ? window.nonceToken
      : null

__webpack_public_path__ =
  window.context && (window.context.aytmWebpackPublicPath || window.context.webpackPublicPath)
    ? window.context.aytmWebpackPublicPath || window.context.webpackPublicPath
    : window.aytmWebpackPublicPath || window.webpackPublicPath
      ? window.aytmWebpackPublicPath || window.webpackPublicPath
      : (() => {
          // Derive publicPath from the current script's URL to match the URL format Rails generates.
          // This prevents webpack's CSS chunk dedup from failing on lazy-loaded chunks when
          // Rails uses asset_host (full URLs) but webpack defaults to relative paths.
          try {
            var src = document.currentScript && document.currentScript.src
            if (src) {
              var url = new URL(src)
              var idx = url.pathname.indexOf('/packs/')
              if (idx !== -1) return url.origin + url.pathname.substring(0, idx) + '/packs/'
            }
          } catch (e) {
            /* ignore */
          }
          return document.location.origin + '/packs/'
        })()

/* eslint-enable no-undef */

if (!window.$WEBPACKER_POLYFILL_INCLUDED) {
  window.$WEBPACKER_POLYFILL_INCLUDED = true
  require('core-js/stable')
}

require('symbol-observable')
